import { poSalesStatusOptions } from './poSales';

const text = value => String(value ?? '').toLocaleLowerCase();
const date = value => String(value || '').slice(0, 10);

export const poSalesFilterFields = [
  { key: 'po_number', label: 'PO Number', value: r => r.po_number },
  { key: 'quote_no', label: 'Quote No.', value: r => [r.offer_no, r.system_quote_no].filter(Boolean).join(' ') },
  ...[['customer', 'Customer'], ['company', 'Company'], ['branch', 'Branch'], ['principal', 'Principal'], ['category', 'Category'], ['sales_executive', 'User']]
    .map(([key, label]) => ({ key, label, type: 'select', value: r => r.quote?.[key]?.name })),
  { key: 'product_code', label: 'Product Code', value: r => r.products?.map(p => p.product_code).join(' ') || r.product_code },
  { key: 'po_amount', label: 'PO Amount', value: r => r.po_amount },
  { key: 'payment_term', label: 'Payment Term', type: 'select', value: r => r.payment_term },
  { key: 'status', label: 'Status', type: 'select', choices: poSalesStatusOptions, value: r => r.status },
  ...[['po_release_date', 'PO Release Date'], ['po_received_date', 'PO Received Date'], ['delivery_due_date', 'Delivery Due Date']]
    .flatMap(([field, label]) => ['start', 'end'].map(bound => ({
      key: `${field}_${bound}`, label: `${label} (${bound === 'start' ? 'Start' : 'End'})`,
      type: 'date', bound, value: r => r[field],
    }))),
];

export const filterPoSales = (records, filters) => records.filter(record => poSalesFilterFields.every(field => {
  const filter = filters[field.key];
  if (!filter || (Array.isArray(filter) && !filter.length)) return true;
  const value = field.value(record);
  if (field.type === 'select') return filter.includes(value);
  if (field.type === 'date') return Boolean(value) && (field.bound === 'start' ? date(value) >= filter : date(value) <= filter);
  return text(value).includes(text(filter).trim());
}));
